<script>
import Page from '~/components/CMS/Page';

export default {
  ...Page,
  nuxtI18n: {
    paths: {
      en: '/legal-notices',
      fr: '/mentions-legales',
    },
  },

  async asyncData({ app, route }) {
      const slug    = route.path.split('/').pop();
      const content = await app.$content(`${app.i18n.locale}/pages`, slug).fetch();
      const data    = { showSocialSharing: false, content: content };
      return data;
  },
};
</script>
